<template>
  <div class="home">
    <Toolbar></Toolbar>
<!--    <div class="test-tab">-->
<!--      <el-link type="info" @click="nav(1)">兴趣测评</el-link>-->
<!--      <el-link type="info"  @click="nav(2)">能力测评</el-link>-->
<!--      <el-link type="info"  @click="nav(3)">性格测评</el-link>-->
<!--    </div>-->
    <div class="content-wrap">
      <div class="content">
        <el-row class="bg" :gutter="30" v-for="(item,i) in baseData" :key="i" :style="{background:`url(${item.backgroundImg}) center center/100% 100% no-repeat`,backgroundSize: 'cover'} ">
          <el-col :xs="24" :sm="24"
                  :md="8" :lg="8" v-for="(j,k) in item.data" :key="k">
            <el-card class="box-card">
            <div style="display: inline-block"  @click="nav(j.type)">
<!--              <img :src="j.img" alt="">-->
              <div class="item-img-bg" :style="{background:`url(${j.img}) center center/100% 100% no-repeat`,backgroundSize: 'cover'} "></div>
              <h2>{{ j.title }}</h2>
              <p>{{ j.content }}</p>
            </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>

<script>
// import { ARow } from 'ant-design-vue'
// import 'ant-design-vue/dist/antd'
import Toolbar from '@/components/toolbar.vue'
import {
  list
} from "@/api/api"

export default {
  name: 'Home',
  data() {
    return {
      baseData: [{
        backgroundImg: require('@/assets/img/home-bg.jpg'),
        data: [
        ]
      },
        // {
        // 	backgroundImg: require('@/assets/img/home/hyjlb-bg4.jpg'),
        // 	data: [{
        // 		img: require('@/assets/img/home/hyjlb-xk.jpg'),
        // 		title: '高考报考学.智选',
        // 		content: '高考报考学·智选系统包括选专业、挑大学、填志愿三个模块，根据考生提供的个人信息，依托赢鼎教育10年的报考咨询经验和高考报考大数据平台，采用智能算法模拟报考专家的报考决策流程，在线实时推荐更符合考生自身的专业方案、高校方案和志愿方案。'
        // 	}, {
        // 		img: require('@/assets/img/home/hyjlb-zx.jpg'),
        // 		title: '高考报考学.智选',
        // 		content: '高考报考学·智选系统包括选专业、挑大学、填志愿三个模块，根据考生提供的个人信息，依托赢鼎教育10年的报考咨询经验和高考报考大数据平台，采用智能算法模拟报考专家的报考决策流程，在线实时推荐更符合考生自身的专业方案、高校方案和志愿方案。'
        // 	}]
        // }
      ],
      cdata: [
        {
          img: require('@/assets/img/xk-bg.jpg'),
          title: '选科测评',
          content: '选科测评是结合学生人格类型测评和能力测评，并将学生特点放到学习场景中，分析孩子学习风格与习惯，从而判断选科倾向。',
          type: 4
        },
      ],
      odata: [
        {
          img: require('@/assets/img/xq-bg.jpg'),
          title: '兴趣测评',
          content: '霍兰德兴趣量表（Self-directed Research）是美国著名的心理学教授约翰•霍兰德（John Holland）基于几十年的职业指导经验研发而成。自上世纪70年代创立以来，经过不断验证和检验，量表体系趋于完善，符合逻辑和实际的科学标准，且拥有广泛的应用实例，已成为美国大考中心、台湾大考中心、美国劳工部等众多高校、机构进行学业规划和职业指导的依据。',
          type: 1,
        }, {
          img: require('@/assets/img/nl-bg.jpg'),
          title: '能力测评',
          content: '能力是指人们顺利完成某种活动所必备的个性心理特征，与性格、兴趣、价值观不同，它直接影响着人们的活动效率，并决定着活动能否完成。每个人都有自己独特的能力系统，如何科学地辨别自己的优势能力和弱势能力，对于个体专业选择和职业发展具有重要的意义。 ',
          type: 2,
        },
        {
          img: require('@/assets/img/xg-bg.jpg'),
          title: '性格测评',
          content: 'MBTI全称“Myers-Briggs Type Indicator”，即“迈尔斯—布莱格斯类型指标”。MBTI是目前世界上最权威、使用最广泛的性格测评工具，由布莱格斯和她的女儿迈尔斯于上世纪40年代开发，其理论基础源自瑞典心理学家荣格（Carl Jung）的心理类型论。经过70余年的研究与发展，已被翻译成近20种世界主要语言，每年进行MBTI测验的人数多达数百万。',
          type: 3,
        }
      ],
      xdata: [
        {
          img: require('@/assets/img/xg-bg.jpg'),
          title: '性格测评',
          content: 'MBTI全称“Myers-Briggs Type Indicator”，即“迈尔斯—布莱格斯类型指标”。MBTI是目前世界上最权威、使用最广泛的性格测评工具，由布莱格斯和她的女儿迈尔斯于上世纪40年代开发，其理论基础源自瑞典心理学家荣格（Carl Jung）的心理类型论。经过70余年的研究与发展，已被翻译成近20种世界主要语言，每年进行MBTI测验的人数多达数百万。',
          type: 3,
        },
      ],
    }
  },
  components: {
    Toolbar
  },
  mounted() {
    this.list();
  },
  methods: {
    nav(type) {
      if(this.$store.state.auth.name) {
        if(type == 4){
          this.$router.push({path:'/courseStart',query: {type}})
        }else{
          this.$router.push({path:'/evaluationStart',query: {type}})
        }
        
      } else {
        this.$confirm('请先设置个人信息，您的信息绝对保密!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push(`/user`)
        })
      }
      // console.log(type,'type')

    },
    list () {
      let that = this
      list({token: this.$store.state.auth.token}).then(res => {
        // console.log(res)
        if (res.code == 1) {
          if(res.data == 2){
            that.baseData[0].data = that.cdata
          }else if(res.data == 1){
            that.baseData[0].data = that.xdata
          }else{
            that.baseData[0].data = that.odata
          }
          
          
        }else if(res.code == -4){
          this.$router.push('/login')
        }
      }).catch(function (err) {
        // console.log(err)
        that.$message.error(err.msg)
      })
    }
  }
}
</script>
<style lang="less" scoped>
// import 'swiper/dist/css/swiper.css'
.swiper-slide {
  background-color: aqua;
  color: red;
}
.test-tab {
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #222;
  //display: flex;
  //justify-content: space-around;


}
.content-wrap {

  > .content {
    //height: 88vh;
    //display: flex;
    //justify-content: space-between;
    //align-content: center;
    color: #fff;
    .bg {
      min-height: 90vh;
      background: center center/100% 100% no-repeat;
      padding: 10vh 10%;
      margin: 0!important;
      /deep/ .el-col {
        margin-bottom: 20px;
        .box-card {
          min-height: 32rem;
          background-color: rgba(255,255,255,0.6);
          cursor: pointer
        }
        > div {
          .item-img-bg {
            height: 18rem;
          }

          h2 {
            margin: 20px 0;
            text-align: center;
            font-size: 19px;
          }

          img {
            width: 100%;
          }

          p {
            font-size: 13px;
          }
        }
      }


    }

  }
}

.el-row {
  margin: 0;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>
